<style scoped lang="scss">
    .logistic_echart > div {
        height: 300px;
    }
    .logistic_total {
    display: flex;
    justify-content: space-between;
        & > span, .ivu-tooltip {
            width: 10.5%;
            text-align: center;
            padding: 10px;
            color: #fff;
            font-weight: bold;
            .ivu-tooltip-rel{
                width: 100%;
            }
        }
    }
</style>
<template>
    <div>
        <div class="right-button">
            <vFormItem label="创建时间" label-width="80" inline>
                <DatePicker type="daterange"
                            placement="bottom-end"
                            placeholder="Select date"
                            ref="createdAt"
                            :value="createdate"
                            @on-change="createTime"
                ></DatePicker>
            </vFormItem>
            <vFormItem label="项目" label-width="80" inline>
                <Select
                    style="width: 150px"
                    v-model="lineidlist"
                    multiple
                    filterable
                    clearable
                >
                    <Option
                        v-for="item in getNewProductList"
                        :key="item.key"
                        :value="item.value"
                        >{{ item.label }}</Option
                    >
                </Select>
            </vFormItem>
            <vFormItem label="来源" label-width="80" inline>
                <Select
                    style="width: 150px"
                    v-model="sourcelist"
                    multiple
                    filterable
                    clearable
                >
                    <Option
                        v-for="item in getSource"
                        :key="item.key"
                        :value="item.value"
                        >{{ item.label }}</Option
                    >
                </Select>
            </vFormItem>
            <vFormItem label="部门" label-width="80" inline>
                <vInput v-model="partment"></vInput>
            </vFormItem>
            <Button
                icon="ios-search"
                class="margin-left-20"
                type="primary"
                @click="submit"
                >确定</Button
            >
            <Button
                icon='md-refresh'
                class="margin-left-10"
                type="default"
                @click="reset"
                >重置</Button
            >
        </div>

        <div class="logistic_total">
            <Tooltip v-for="(item, index) in numberReport" :key="index" :content="item.title" :class="item.theme" placement="top">    
                <Icon class="margin-right-5" type="md-help-circle" />
                <span>{{ item.label }}: {{ item.value }}</span>
            </Tooltip>
        </div>

        <div class="logistic_echart margin-top-30 margin-bottom-20 clearfix">
            <div class="echart_bar1 width-50per pull-left"></div>
            <div class="echart_bar2 width-50per pull-left"></div>

            <div class="width-50per pull-left">
                <div class="text-right padding-top-10 padding-right-10" v-show="arrdate1.length>0 || arrdate2.length>0">
                    <vButton v-if="showliang" class="margin-right-10" @click="clickliang"><vIcon type="git-compare" />切换计划上新量</vButton>
                    <vButton v-if="!showliang" class="margin-right-10" @click="clickliang"><vIcon type="git-compare" />切换实际上新分析</vButton>
                </div>
                <div class="echart_line" style="height: 250px;width:100%"></div>
            </div>
            <div class="echart_bar3 width-50per pull-left"></div>

            <div class="echart_pei1 width-50per pull-left"></div>
            <div class="echart_pei2 width-50per pull-left"></div>
        </div>
    </div>
</template>

<script>

import { mapState,mapGetters } from "vuex";
import mixin from './mixins'
import { HttpproductDevelopmentPreselection } from "@/service/proddevelop";

export default {
    mixins: [mixin],
    data(){
        return {
            createdate:[],
            lineidlist:[],
            sourcelist:[],
            partment:null,
            numberReport:[],
            showliang:false,
            arrdate1:[],
            arrdate2:[],
            
        }
    },
    created(){
        this.getDetail()
    },
    computed:{
        ...mapGetters('diction',['getNewProductList','getAllProductPerson']),
    },
    methods:{
        getDetail(){
            this.createdate = [
                this.getDay(-30),
                this.getDay(0),
            ];
            this.submit()
        },
        submit(){
            HttpproductDevelopmentPreselection({
                startTime:this.createdate[0],
                endTime:this.createdate[1],
                lineIds:this.lineidlist,
                source:this.sourcelist,
                department:this.partment,
            }).then(res=>{
                console.log(res)
                // 总数按钮
                let index = 0;
                let initData = [
                        {label:'总计',value:0,theme:'danger',title:'不含草稿状态还未提交的单据'},
                        {label:'待审核',value:0,theme:'primary',title:'待审核'},
                        {label:'待询价',value:0,theme:'warning',title:'待询价'},
                        {label:'待确认报价',value:0,theme:'success',title:'待确认报价'},
                        {label:'待打样',value:0,theme:'gary',title:'待打样'},
                        {label:'待确认打样工厂',value:0,theme:'primary',title:'待确认打样工厂'},
                        {label:'待正式建档',value:0,theme:'warning',title:'待正式建档'},
                        {label:'已建档',value:0,theme:'success',title:'已建档'},
                        {label:'已取消',value:0,theme:'danger',title:'已取消'},
                    ];
                if(res.data.statusMap == null){
                    this.numberReport = initData
                }else{
                    this.numberReport = []
                    initData.map(item=>{
                        for(let key in res.data.statusMap){
                            if(item.label == key){
                                item.value = res.data.statusMap[item.label];
                            }
                        }
                    })
                    this.numberReport = initData
                }

                let delay1 = [], delay2 = [];
                for (let key2 in res.data.delayMap) {
                    delay1.push(key2);
                    delay2.push(res.data.delayMap[key2]);
                }
                this.drawEchartBar1({delay1,delay2})

                let delay3 = [],delay5 = [],num1=[],num2=[],num3=[];
                for (let key2 in res.data.percentageMap) {
                    delay3.push(key2);
                    for(let key3 in res.data.percentageMap[key2]){
                        if(key3 === '7天内'){
                            num1.push(res.data.percentageMap[key2][key3])
                        }else if(key3=== '14天以上'){
                            num2.push(res.data.percentageMap[key2][key3])
                        }else{
                            num3.push(res.data.percentageMap[key2][key3])
                        }
                    }
                }
                this.drawEchartBar2({delay3,num1,num2,num3})

                // 中间折线和柱状图
                // recommendMap，shelvesMap
                let number1=[],number2=[]
                for(let key in res.data.recommendMap){
                    number1.push({label:key,value:res.data.recommendMap[key]})
                }
                for(let key in res.data.shelvesMap){
                    number2.push({label:key,value:res.data.shelvesMap[key]})
                }
                
                this.arrdate1 = this.compareFN(number1,'label')
                this.arrdate2 = this.compareFN(number2,'label')
                this.drawLine();

                let delay7 = [], delay8 = [];
                for (let key2 in res.data.departmentMap) {
                    delay7.push({label:key2,value:res.data.departmentMap[key2]})
                }
                delay8 = this.compareFN(delay7,'value')
                this.drawEchartBar3(delay8)

                // 做各个图形的转换数据
                let sourcedata = [],categorydata = [];
                
                for(let key in res.data.sourceMap){
                    let data = {
                        name:key,
                        value:res.data.sourceMap[key]
                    }
                    sourcedata.push(data)
                }
                this.drawEchartPie1(sourcedata);

                for(let key in res.data.categoryMap){
                    let data = {
                        name:key,
                        value:res.data.categoryMap[key]
                    }
                    categorydata.push(data)
                }
                this.drawEchartPie2(categorydata); 
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        reset(){
            this.lineidlist = [];
            this.sourcelist = [];
            this.partment = null;
            this.getDetail()
        },
        createTime(data){
            this.createdate = [
                data[0],
                data[1],
            ];
        },
        // 两个柱状
        drawEchartBar1({ delay1, delay2 }) {
            const echart = Echarts.init(this.$el.querySelector(".echart_bar1"));

            if(delay1.length == 0){
                echart.clear();
                echart.setOption({
                    title: {
                        text: "延迟情况",
                        left: "center",
                        itemGap: 110,
                        subtext:'暂无数据...',
                        subtextStyle: {
                            fontSize: 18,
                            color: '#666',
                            fontWeight: 'normal',
                            align:'center',
                            baseline: 'middle',
                        },
                    },
                    
                })
            }else{
                echart.clear();
                // 绘制图表
                echart.setOption({
                    title: {
                        text: "延迟情况",
                        left: "center",
                    },
                    tooltip: { trigger: "axis" },
                    xAxis: {
                        type: "category",
                        data: delay1,
                        axisLabel: {
                            interval: 0,
                        },
                    },
                    yAxis: {
                        type: "value",
                    },
                    series: [
                        {
                            name: "总数量",
                            data: delay2,
                            type: "bar",
                            color:'#f90'
                        },
                    ],
                });
            }
        },
        drawEchartBar2({ delay3,num1,num2,num3 }) {
            const echart = Echarts.init(this.$el.querySelector(".echart_bar2"));
            if(delay3.length == 0){
                echart.clear();
                echart.setOption({
                    title: {
                        text: "延迟占比",
                        left: "center",
                        itemGap: 110,
                        subtext:'暂无数据...',
                        subtextStyle: {
                            fontSize: 18,
                            color: '#666',
                            fontWeight: 'normal',
                            align:'center',
                            baseline: 'middle',
                        },
                    },
                    
                })
            }else{
                echart.clear();
                // 绘制图表
                echart.setOption({
                    title: {
                        text: "延迟占比",
                        left: "center",
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    xAxis: {
                        type: "category",
                        data: delay3,
                        axisLabel: {
                            interval: 0,
                        },
                    },
                    yAxis: {
                        type: "value",
                    },
                    series: [
                        {
                            name: '7天以内',
                            data: num1,
                            type: 'bar',
                            stack: 'one',
                            color:'#19be6b'
                        },
                        {
                            name: '7-14天',
                            data: num3,
                            type: 'bar',
                            stack: 'one',
                            color:'#2db7f5'
                        },
                        {
                            name: '14天以上',
                            data: num2,
                            type: 'bar',
                            stack: 'one',
                            color:'#ed3f14'
                        }
                    ]
                });
            }
        },
        clickliang(){
            this.showliang = !this.showliang;
            this.drawLine()
        },
        // 中间折线加柱状
        drawLine(){
            const echart = Echarts.init(this.$el.querySelector(".echart_line"));
            var colors = ['#5793f3', '#d14a61', '#675bba'];
            let linetitle = this.showliang == false ? ' 计划上新量 ' : ' 实际上新分析 ';
            let datelabel1=[],datelabel2=[],datevalue1=[],datevalue2=[];
            this.arrdate1.map(item=>{
                datelabel1.push(item.label)
                datevalue1.push(item.value)
            })
            this.arrdate2.map(item=>{
                datelabel2.push(item.label)
                datevalue2.push(item.value)
            })
            
            if(this.arrdate1.length == 0){
                echart.clear();
                echart.setOption({
                    title: {
                        text: this.showliang == false ? '计划上新量' : '实际上新分析',
                        left: "center",
                        itemGap: 110,
                        subtext:'暂无数据...',
                        subtextStyle: {
                            fontSize: 18,
                            color: '#666',
                            fontWeight: 'normal',
                            align:'center',
                            baseline: 'middle',
                        },
                    },
                    
                })
            }else{
                echart.clear();
                echart.setOption({
                    title: {
                        text: this.showliang == false ? '计划上新量' : '实际上新分析',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'axis',
                    },
                    legend: {
                        left: 'center',
                        data: linetitle,
                        bottom:0
                    },
                    xAxis: 
                    {
                        data: this.showliang == false ? datelabel1 : datelabel2
                    },
                    yAxis: {
                        type: 'value',
                    },
                    grid: {
                        top: '12%',
                        left: '3%',
                        right: '3%',
                        containLabel: true
                    },
                    series: [
                        {
                            name:linetitle,
                            type:'line',
                            data: this.showliang == false ? datevalue1 : datevalue2
                        },
                    ]
                })
            }
        },
        drawEchartBar3(delay8) {
            delay8.reverse();
            let datelabel1=[],datevalue1=[];
            delay8.map(item=>{
                datelabel1.push(item.label)
                datevalue1.push(item.value)
            })
            const echart = Echarts.init(this.$el.querySelector(".echart_bar3"));

            if(delay8.length == 0){
                echart.clear();
                echart.setOption({
                    title: {
                        text: "部门分布情况",
                        left: "center",
                        itemGap: 110,
                        subtext:'暂无数据...',
                        subtextStyle: {
                            fontSize: 18,
                            color: '#666',
                            fontWeight: 'normal',
                            align:'center',
                            baseline: 'middle',
                        },
                    },
                    
                })
            }else{
                echart.clear();
                // 绘制图表
                echart.setOption({
                    title: {
                        text: "部门分布情况",
                        left: "center",
                    },
                    tooltip: { trigger: "axis" },
                    xAxis: {
                        type: "category",
                        data: datelabel1,
                        axisLabel: {
                            interval: 0,
                        },
                    },
                    yAxis: {
                        type: "value",
                    },
                    series: [
                        {
                            name: "总数量",
                            data: datevalue1,
                            type: "bar",
                            color:'#19be6b'
                        },
                    ],
                });
            }
        },
        // 两个饼图
        drawEchartPie1(sourcedata) {
            const echart = Echarts.init(this.$el.querySelector(".echart_pei1"));

            if(sourcedata.length == 0){
                echart.clear();
                echart.setOption({
                    title: {
                        text: "推荐来源分布",
                        left: "center",
                        itemGap: 110,
                        subtext:'暂无数据...',
                        subtextStyle: {
                            fontSize: 18,
                            color: '#666',
                            fontWeight: 'normal',
                            align:'center',
                            baseline: 'middle',
                        },
                    },
                    
                })
            }else{
                echart.clear();
                echart.setOption({
                    title: {
                        text: "推荐来源分布",
                        left: "center",
                    },
                    tooltip: {
                        trigger: "item",
                        formatter: "{a} <br/>{b} : {c} ({d}%)",
                    },
                    legend: {
                        orient: "vertical",
                        left: 10,
                        top: 20,
                        itemGap: 15,
                        itemWidth: 10,
                    },
                    color:['#2db7f5','#808695','#ed3f14','#19be6b','#f90'],
                    series : [
                        {
                            name: '推荐来源分布',
                            type: 'pie',
                            radius : '55%',
                            center: ['50%', '60%'],
                            data: sourcedata,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                                }
                            }
                        }
                    ]
                });
            }
        },
        drawEchartPie2(categorydata) {
            const echart = Echarts.init(this.$el.querySelector(".echart_pei2"));

            if(categorydata.length == 0){
                echart.clear();
                echart.setOption({
                    title: {
                        text: "品类分布",
                        left: "center",
                        itemGap: 110,
                        subtext:'暂无数据...',
                        subtextStyle: {
                            fontSize: 18,
                            color: '#666',
                            fontWeight: 'normal',
                            align:'center',
                            baseline: 'middle',
                        },
                    },
                    
                })
            }else{
                echart.clear();
                echart.setOption({
                    title: {
                        text: "品类分布",
                        left: "center",
                    },
                    tooltip: {
                        trigger: "item",
                        formatter: "{a} <br/>{b} : {c} ({d}%)",
                    },
                    legend: {
                        orient: "vertical",
                        left: 10,
                        top: 20,
                        itemGap: 15,
                        itemWidth: 10,
                    },
                    color:['#2db7f5','#f90','#808695','#19be6b','#ed3f14'],
                    series : [
                        {
                            name: '品类分布',
                            type: 'pie',
                            radius : '55%',
                            center: ['50%', '60%'],
                            data: categorydata,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                                }
                            }
                        }
                    ]
                });
            }
        },
    }
}
</script>